import { Select } from '@radix-ui/themes'

type Props = {
	name: string
	options: Array<{ value: any; label: string }>
	label?: string
	defaultValue?: string
	size?: '1' | '2' | '3'
	onChange?: (value: string) => any
}
export default function SelectInput(props: Props) {
	return (
		<div className="flex flex-col">
			<label>{props?.label}</label>
			<Select.Root
				name={props.name}
				defaultValue={props.defaultValue}
				size={props.size || '3'}
				onValueChange={props.onChange}
			>
				<Select.Trigger />
				<Select.Content>
					<Select.Group>
						{props.options.map(({ value, label }) => (
							<Select.Item key={value} value={value}>
								{label}
							</Select.Item>
						))}
					</Select.Group>
				</Select.Content>
			</Select.Root>
		</div>
	)
}
